import Swal from "sweetalert2";

export const showAlert = (
  navigate, // Pass navigate as an argument
  title,
  html,
  icon = "info",
  width = "500px",
  confirmButtonText = "OK", // Default is OK
  redirectTo = null, // Default redirect URL
  dispatch = null,  // Redux dispatch function, optional
  reduxAction = null, // Redux action to dispatch, optional (should be passed as a function)
  useConfirmCancel = false,  // Flag to toggle between OK and Yes/No
  cancelButtonText = "No", // Optional cancel button text if useConfirmCancel is true
  handleOk = null,// Function to handle OK click,
  handleCancel = null,// Function to handle OK click,
  showCloseButton = false
) => {
  let textColor;

  switch (icon) {
    case "success":
      textColor = "#28a745"; // Green for success
      break;
    case "warning":
      textColor = "#cbad52"; // Yellow for warning
      break;
    case "error":
      textColor = "#dc3545"; // Red for error
      break;
    case "info":
    default:
      textColor = "#4a9a93"; // Blue for info
      break;
  }

  // Show alert with OK or Yes/No buttons based on `useConfirmCancel` flag
  return Swal.fire({
    title,
    html: `<span style="color: ${'#1d1d1d'};">${html}</span>`,
    icon,
    showCancelButton: useConfirmCancel,  // Show cancel button if `useConfirmCancel` is true
    confirmButtonText,  // Either OK or Yes, depending on usage
    cancelButtonText,  // Only relevant if `useConfirmCancel` is true
    showCloseButton: showCloseButton,
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      confirmButton: "btn button-primary",
      cancelButton: "btn button-secondary"
    },
    showClass: {
      popup: '' // No animation
    },
    hideClass: {
      popup: '' // No animation
    }
  }).then((result) => {
    if (result.isConfirmed) {
      // Call the handleOk function if provided
      if (handleOk && typeof handleOk === 'function') {
        handleOk();
      }
      // If confirmed, dispatch Redux action if provided
      if (reduxAction && typeof reduxAction === 'function' && dispatch) {
        // Dispatch the redux action and ensure it is a function for redux-thunk to handle
        dispatch(reduxAction());
      }

      // Navigate to the specified URL, if provided
      if (redirectTo) {
        navigate(redirectTo);
      }
    } else if (result.isDismissed && useConfirmCancel && result?.dismiss !== "close" && result?.dismiss !== "backdrop") {
      if (handleCancel && typeof handleOk === 'function') {
        handleCancel();
      }

    }
  });
};
